import { SettingOutlined } from "@ant-design/icons";
import {
  DISCOVER_ONLY_DEFAULT_SETTINGS,
  GraphSearchSettings,
} from "@p0security/shared/graph/settings";
import { Button, Form, InputNumber, Popover } from "antd";
import { useCallback } from "react";
import styled from "styled-components";

export type GraphSearchSettingsDisables = Partial<
  Record<keyof GraphSearchSettings, boolean> //If exists, disables that setting with the give value
>;

export type GraphSearchSettingsControlProps = {
  disables: GraphSearchSettingsDisables;
  settings: GraphSearchSettings;
  setSettings: (settings: GraphSearchSettings) => void;
};

const GraphSearchSettingsForm = styled(Form)`
  .ant-form-item {
    margin-bottom: 12px;
    :last-child {
      margin-bottom: 0;
    }
  }
`;

export const GraphSearchSettingsControl: React.FC<
  GraphSearchSettingsControlProps
> = ({ disables, settings, setSettings }) => {
  const handleChangeMaxResults = useCallback(
    (maxResults: number | null) =>
      setSettings({
        ...settings,
        maxResults: maxResults,
      }),
    [setSettings, settings]
  );
  const handleChangeMaxPaths = useCallback(
    (maxPaths: number | null) =>
      setSettings({
        ...settings,
        maxPaths: maxPaths,
      }),
    [setSettings, settings]
  );
  return (
    // Hide the popover if all the settings are disabled
    !disables.maxResults || !disables.maxPaths ? (
      <Popover
        content={
          <GraphSearchSettingsForm>
            {!disables.maxResults && (
              <Form.Item label="Max results">
                <InputNumber
                  disabled={disables.maxResults}
                  min={1}
                  max={1000}
                  value={
                    disables.maxResults
                      ? DISCOVER_ONLY_DEFAULT_SETTINGS.maxResults
                      : settings.maxResults
                  }
                  onChange={handleChangeMaxResults}
                />
              </Form.Item>
            )}
            {!disables.maxPaths && (
              <Form.Item label="Max paths">
                <InputNumber
                  disabled={disables.maxPaths}
                  min={1}
                  max={1000}
                  value={
                    disables.maxPaths
                      ? DISCOVER_ONLY_DEFAULT_SETTINGS.maxPaths
                      : settings.maxPaths
                  }
                  onChange={handleChangeMaxPaths}
                />
              </Form.Item>
            )}
          </GraphSearchSettingsForm>
        }
        placement="bottom"
        trigger="click"
      >
        <Button icon={<SettingOutlined />} />
      </Popover>
    ) : null
  );
};
